import { render, staticRenderFns } from "./ex.vue?vue&type=template&id=2dce669a&"
import script from "./ex.vue?vue&type=script&lang=js&"
export * from "./ex.vue?vue&type=script&lang=js&"
import style0 from "./ex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports